module.exports = __webpack_public_path__ + "static/media/newPatient.4bec2b84.png";